//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {detailData,saveInvoRecordInfo,getContCmp} from '@/api/cmInvo/contInvoice';
	import {getDicData} from '@/api/common/dic';
	import {previewFile} from '@/utils/common';
	import { Toast } from 'mint-ui';

	export default {
		name:'invoListPage',
		data(){
	      return {
	      	// 标记
	      	flag:this.$route.params.flag,
	      	// 公司名称
	      	comName:this.$route.params.comName,
	      	// 开票id
	      	mainId:this.$route.params.mainId,
	      	// 开票类型 1：人天服务  2：人天服务总价
	      	invoType:this.$route.params.invoType,
      		// 是否从审批跳转
      		isAppr:this.$route.params.isAppr,
	      	// 开票主表是数据
	      	invoFrom:{},
	      	// 合同数据
	      	contInfo:{},
	      	// 公司选择弹框
	      	comSelDialogFlag:false,
	      	// 公司下拉数据
	      	comSelOptions:[],
	      	// 选择的公司数据
	      	selComData:{
	      		comId:'',
	      		comCode:'',
	      		comName:''
	      	},
          // 税率
          taxRateOptions:[],
          //开票内容
          invoContentOptions:[],
	      }
		},
		created(){
			this.getDicData();
			// 加载数据
			this.loadData();
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			// 文件预览 下载
			preview(fileId){
				previewFile(fileId);
			},
			// 返回
			goback(){
			  if(this.isAppr === '1'){
			    // 审批方式跳转过来的，跳转至代办页
			    this.$router.push({ path: '/' });
			  }else{
			    // 跳转至上一页
			    this.$router.go(-1);
			  }
			},
		    // 加载数据
		    loadData(){

		    	if(this.flag === '0'){
		    		// 创建
		    		// 根据公司名称获取对应的人天服务合同信息

		    	}else{
		    		// 编辑、查看
		    	}
		    	// 根据公司名称，获取人天服务合同信息

		        var condition = {'invoId':this.mainId,'flag':this.flag,'cmpName':this.comName,'invoType':this.invoType};
		        detailData(condition).then(response => {
		        	// 数据赋值
	          		this.invoFrom = response.invoRecordData;
	          		this.contInfo = response.contractData;
		        });
		    },
		    // 保存
		    saveClick(){
		    	// 保存
		    	this.saveFn("1");
		    },
		    // 提交
		    submitClick(){

		    	if(this.invoFrom.invoStartDate===null ||  this.invoFrom.invoStartDate===undefined || this.invoFrom.invoStartDate===''
		    		||this.invoFrom.invoEndDate===null ||  this.invoFrom.invoEndDate===undefined || this.invoFrom.invoEndDate===''){
		    		Toast({
					  message: '请选择结算起止日期！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}

		    	if(this.invoFrom.invoAmt===null || isNaN(this.invoFrom.invoAmt) || this.invoFrom.invoAmt===undefined || this.invoFrom.invoAmt===''){
		    		Toast({
					  message: '请填写价税合计！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}

          if(this.invoFrom.taxRate===null  || this.invoFrom.taxRate===undefined || this.invoFrom.taxRate===''){
		    		Toast({
					  message: '请选择税率！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}

		    	if(this.invoFrom.invoContent===null || this.invoFrom.invoContent===undefined || this.invoFrom.invoContent===''){
	                Toast({
					  message: '请填写开票内容！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}
          if(this.invoFrom.preReturnDate===null || this.invoFrom.preReturnDate===undefined || this.invoFrom.preReturnDate===''){
            Toast({
              message: '请选择预计回款时间！',
              position: 'middle',
              duration: 1500,
              className:'info'
            });
            return;
          }

		    	// 记录提交日期
		    	this.invoFrom.applyDate = new Date();
		    	// 提交，暂时保存处理
		    	this.saveFn("1");
		    },
		    // 保存，isSubmit 是否为提交， 1：提交  0：保存
		    saveFn(isSubmit){
		    	// 开票类型
		    	this.invoFrom.invoStatus = '全部开票';

		    	var invoRecordData = JSON.stringify(this.invoFrom);
		    	// 不存在，设置成空字符串
		    	var outSourceData = "";
		    	// invoType, 0:阶段性合同开票 1:人工服务开票 2:人体服务总价开票
		        var data = {'invoType':this.invoType,'invoRecordData':invoRecordData,'outSourceData':outSourceData,
		    		'isSubmit':isSubmit,'isEdit':this.flag};
		        saveInvoRecordInfo(data).then(response => {
		        	if(response.flag === 'S'){
		    			if(isSubmit == '1'){
		    				// 提交情况下
		    				Toast({
							  message: '开票申请提交成功！',
							  position: 'middle',
							  duration: 1500,
							  className:'success'
							});
		    				// 返回列表界面
		    				this.goback();
		    			}else{
		    				Toast({
							  message: '开票申请保存成功！',
							  position: 'middle',
							  duration: 1500,
							  className:'success'
							});
		    			}
		        	}else{
	    				Toast({
						  message: '开票申请失败：'+response.msg,
						  position: 'middle',
						  duration: 1500,
						  className:'warning'
						});
		        	}
		        });
		    },
		    // 加载合同的客户公司
		    loadCompany(invoType){
		    	var condition = {'invoType':invoType};
		        getContCmp(condition).then(response => {
		        	this.comSelOptions = response.contCmpData;
		        });
		    },
		    // 重新选择公司
		    reSelect(){
		    	// 设置开票类型
	    		this.comSelDialogFlag = true;
	    		this.loadCompany(this.invoType);
		    },
		    // 取消dialog
		    cancleDialog(){
		    	this.comSelDialogFlag = false;
		    },
		    // 确认
		    confirmDialog(){
		    	if(this.selComData.comName === ''){
		    		Toast({
					  message: '请选择公司！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}

		    	this.comSelDialogFlag = false;
		    	// 选择的公司名称
		    	this.comName = this.selComData.comName;

				// 加载数据
				this.flag='0';
				this.loadData();
		    },
		    // 字典表数据
		    getDicData(){
		        // 税率
		        var condition = {'cateCode':'taxRate'};
		        getDicData(condition).then(response => {
		          this.taxRateOptions = response;
		        });
          condition = {'cateCode':'invoContent'};
          getDicData(condition).then(response => {
            this.invoContentOptions = response;
          });
		    },
		    // 总金额更改事件
		    amtChange(val){
		    	this.calcAmtDeal();
		    },
		    // 税率更改事件
		    taxRateChange(val){
		    	this.calcAmtDeal();
		    },
		    calcAmtDeal(){
		    	var invoAmt = this.invoFrom.invoAmt;
		    	var taxRate = this.invoFrom.taxRate;
		    	if(taxRate != null && taxRate!=undefined && taxRate != ''
		    		&& invoAmt != null && invoAmt!=undefined && invoAmt != '' ){
		    		taxRate = parseFloat(taxRate.replace('%',''))/100;
		    		this.invoFrom.actTaxAmt = parseFloat((parseFloat(invoAmt)*taxRate/(1+taxRate)).toFixed(2));
		    		this.invoFrom.actNetAmt = parseFloat((parseFloat(invoAmt) - this.invoFrom.actTaxAmt).toFixed(2));
		    	}
		    }
		}
	}



// WEBPACK FOOTER //
// ./src/view/cmInvo/invo/invoHdTotalDetail.vue